import { css } from '@emotion/css';

export const inputStyles = css`
  textarea {
    padding: 0;
  }
`;
